import { ComponentType, useCallback } from "react";
import { Dayjs } from "dayjs";

import DatePickerJs from "../../../shared/DatePicker/DatePicker";
import ExportToXlsxButtonJs from "../../../CommonComponents/ExportToXlsxButton/ExportToXlsxButton";
import type { ExportRow } from "../../../../queries/payments/usePaymentReporting";

import styles from "./PaymentReportingHeader.module.css";

type DateRange = [Dayjs, Dayjs];

const DatePicker = DatePickerJs as ComponentType<{
  getData: (queryString: string | null) => void;
  dates: DateRange;
  setDates: (dates: DateRange) => void;
  showPresets?: boolean;
}>;

const ExportToXlsxButton = ExportToXlsxButtonJs as ComponentType<{
  filename?: string;
  data?: object[];
  loadData?: () => Promise<object[]>;
}>;

interface PaymentReportingHeaderProps {
  dates: DateRange;
  setDates: (dates: DateRange) => void;
  exportRows?: ExportRow[];
}

const PaymentReportingHeader: React.FC<PaymentReportingHeaderProps> = ({
  dates,
  setDates,
  exportRows = [],
}) => {
  const getData = useCallback(() => {}, []);

  return (
    <div className={styles.header}>
      <div className={styles.controls}>
        <DatePicker
          getData={getData}
          dates={dates}
          setDates={setDates}
          showPresets
        />
        <ExportToXlsxButton
          data={exportRows}
          filename="payment-reporting.xlsx"
        />
      </div>
    </div>
  );
};

export default PaymentReportingHeader;
